export default __webpack_public_path__ + "static/media/minus.088c3818.svg";